// Scrolly-Viewer — Route `/<orgSlug>/<scrollySlug>` (Backwards-Compat).
//
// Plan-1.9 Phase 4 STOPP 4.A.8 introduced this route for Master-Briefing
// v5 Z. 435 ("alte Bookmarks funktionieren weiter: ...
// `viewer.scrolly.com/{orgSlug}/{scrollySlug}`"). Strict route function
// in `+route.ts` excludes reserved top-level segments to avoid catch-all
// conflicts with other Vike pages (s, scrolly, scrollytelling, category,
// preview, __dev__, _error).
//
// Functionally identical to `/s/:slug` rendering — only the resolver in
// `+data.ts` differs (resolveScrollyByOrgSlug against
// `/public/scrollys/by-slug/...`). No mock-fallback path (Production-only
// route).

import { usePageContext } from "../../../src/hooks/usePageContext";
import { ScrollyViewerPage } from "../../../src/components/viewer/ScrollyViewerPage";
import type { ResolvedScrollyPageData } from "../../../src/lib/api/resolved-scrolly-page-data";

export default function Page() {
  const pageContext = usePageContext();
  const orgSlug = pageContext.routeParams?.orgSlug ?? "";
  const scrollySlug = pageContext.routeParams?.scrollySlug ?? "";
  const urlKey = `${orgSlug}/${scrollySlug}`;
  const pageData = pageContext.data as ResolvedScrollyPageData | undefined;
  return (
    <ScrollyViewerPage
      pageContext={pageContext}
      pageData={pageData}
      urlKey={urlKey}
      notFoundUrlPrefix=""
    />
  );
}
